import React from 'react';
import { TextCompare } from '../components/text-compare/TextCompare';
import '../components/text-compare/TextCompare.css';

export const TextComparePage: React.FC = () => {
  return (
    <div className="page-container">
      <TextCompare />
    </div>
  );
};
